import { PanelHeader } from '../../../../../components/Panel/PanelHeader';
import { PanelFooter } from '../../../../../components/Panel/PanelFooter';
import { UseComboRazon } from '../../../../../hooks/auxiliar/combo/UseComboRazon';
import { useComboTipoEquipos } from '../../../../../hooks/auxiliar/combo/UseComboTipoEquipo';
import { IFilter2, IT, keyType, textType } from '../UseRazonModelo';
import { IComboBoxOption, Panel, PanelType } from '@fluentui/react';
import { ComboBoxComponent } from '../../../../../components/comboBox/ComboBoxComponent';

export interface IPanelHistorico {
    filter2: IFilter2;
    isOpen: boolean;
    equipoAuxiliar?: boolean,
    onChangeComboFilter: (data: IT) => void
    resetFilter2: () => void;
    buscar: () => void;
    onDismiss: () => void;
}

interface IR {
    data?: IComboBoxOption,
    key: keyType,
    text: textType
}
export const PanelRazonModeloFiltrar = ({
    isOpen,
    resetFilter2,
    onChangeComboFilter,
    filter2,
    buscar,
    onDismiss
}: IPanelHistorico) => {


    const { dataComboRazon, filter, setFilter } = UseComboRazon(isOpen);
    const { dataComboTipoE, setFilterTipoE, filterTipoE } = useComboTipoEquipos({ isOpen, equipoAuxiliar: true });

    const handleOnChange = ({ data, key, text }: IR) => {
        if (data) {
            onChangeComboFilter({
                key,
                keyValue: `${data.key}`,
                text,
                textValue: data.text
            })
        }
    };
    return (
        <>
            <Panel
                type={PanelType.smallFixedFar}
                onRenderHeader={() =>
                    <PanelHeader
                        textHeader="Filtrar Razón Modelo"
                        subTextHeader={`Búsqueda Avanzada`}
                    />
                }
                onRenderFooter={() =>
                    <PanelFooter
                        texto="Buscar"
                        texto2={"Limpiar"}
                        onClick={buscar}
                        disableButton={false}
                        onDismiss={resetFilter2}
                    />
                }
                isFooterAtBottom
                isOpen={isOpen}
                onDismiss={onDismiss}
            >
                <div className="ms-Grid" dir="ltr">
                    <ComboBoxComponent
                        text="Razón:"
                        selectedKey={filter2.razonKey}
                        placeholder="Seleccione una Razón"
                        value={filter2.razonText}
                        onChange={(value) => {
                            setFilter({
                                ...filter,
                                search: value
                            })
                        }}
                        onOptionSelect={(event, option) => {
                            handleOnChange({
                                data: option,
                                key: 'razonKey',
                                text: 'razonText'
                            })
                        }}
                        defaultSelectedOptions={[{
                            key: filter2.razonKey,
                            text: filter2.razonText
                        }]}
                        data={dataComboRazon}
                    />

                    {/* <TextField
                            type="text"
                            label="Nombre de Razón Modelo"
                            placeholder="Ingrese Nombre"
                            autoComplete="off"
                            value={filter2.}
                            onChange={(event, newValue) => {
                                if (newValue != null) {
                                    props.setFiltro({ ...props.filtro, nombre: newValue })
                                }
                            }}
                        /> */}
                </div>
            </Panel>
        </>
    )
}

